import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import { CircularProgress } from '@mui/material';
import AlgoStatsTooltip from '../components/AlgoStatsTooltip.js'
import AlgoDrawer from '../algos/AlgoDrawer.js'
import StockQuickLookDrawer from '../stock/StockQuickLookDrawer.js'

function SneakPeek(props) {

    const [isLoading, setIsLoading] = useState(false);
    const [previewTrades, setPreviewTrades] = useState(null);
    const [updates, setUpdates] = useState(0);

    useEffect(() => {
        (async function () {

            setIsLoading(true);
            console.log("loadTradePreview")
            setPreviewTrades(null);
            const url = `/api/strategyAlertTradePreview?returnAll=true&planId=` + props.planId;
            const trades = await (await fetch(url)).json();
            console.log("previewTrades", trades);
            setPreviewTrades(trades.sort((a, b) => a.symbol < b.symbol ? -1 : 1));
            setIsLoading(false);

        })();
    }, [props.planId, updates]);

    function reloadData() {
        setUpdates(updates + 1)
    }

    function getAggregateTrades() {
        let results = []
        previewTrades.forEach(trade => {
            let existing = results.find(r => r.symbol === trade.symbol)
            if (existing) {
                if (trade.action.toUpperCase() === "BUY") {
                    existing.percentage += trade.percentage;
                } else {
                    existing.percentage -= trade.percentage;
                }
            } else {
                results.push({ symbol: trade.symbol, percentage: trade.action.toUpperCase() === "BUY" ? trade.percentage : trade.percentage * -1 })
            }
        })
        return results;
    }


    function getTradePreview() {
        if (previewTrades === null) {
            return <div>Checking...</div>
        } else if (previewTrades.length === 0) {
            return <div>No trades as of right now</div>
        } else {
            return (
                <div>
                    Things might change so don't take action yet...<br></br>
                    <ul>
                        {
                            previewTrades.filter(t => t.action !== 'none' && t.action !== 'hold').map(t =>
                                <li key={t.algoId}><div class='sameline'>{t.action.toUpperCase()} {props.supressAllocations ? null : `${t.percentage}% of `}<StockQuickLookDrawer symbol={t.symbol} planId={props.planId} mobileView={props.mobileView} /> by <AlgoDrawer link={t.display_name} planId={props.planId} accountId={props.accountId} userId={props.userId} mobileView={props.mobileView} algoId={t.algoId} role={props.role} />&nbsp;<AlgoStatsTooltip position={"right center"} algoId={t.algoId} />{t.profitPercentage ? (t.profitPercentage > 0 ? " for profit" : " for loss") : null} {t.reason ? " (" + t.reason.toUpperCase() + ")" : null}</div></li>
                            )
                        }
                    </ul>

                    {props.supressAllocations ? null :
                        <>
                            Summary:<br></br>
                            <ul>
                                {
                                    getAggregateTrades().filter(a => a.percentage !== 0).map(t =>
                                        <li key={t.symbol} ><div className='sameline'>{t.percentage > 0 ? "+" : ""}{t.percentage}% of <StockQuickLookDrawer symbol={t.symbol} planId={props.planId} mobileView={props.mobileView} /></div></li>
                                    )
                                }
                            </ul>
                        </>
                    }

                    <br></br>
                    No Action
                    <ul>
                        {
                            previewTrades.sort((a, b) => a.reason < b.reason ? -1 : 1).filter(t => t.action === 'none').map(t =>
                                <li key={t.algoId}><div class='sameline'><StockQuickLookDrawer symbol={t.symbol} planId={props.planId} mobileView={props.mobileView} /> by <AlgoDrawer link={t.display_name} planId={props.planId} accountId={props.accountId} userId={props.userId} mobileView={props.mobileView} algoId={t.algoId} role={props.role} />&nbsp;<AlgoStatsTooltip position={"right center"} algoId={t.algoId} />{t.reason ? " (" + t.reason.toUpperCase() + ")" : null}</div></li>
                            )
                        }
                    </ul>

                </div>
            )
        }
    }

    return (
        <>
            {isLoading ?
                <CircularProgress />
                :
                <>
                    {getTradePreview()}
                    <Link onClick={reloadData}>🔄 Reload</Link>
                </>
            }

        </>
    );
}

export default SneakPeek;